function interpolateNumber(a,b){a=+a,b=+b;let c=b-a;return b=>c*b+a}export default interpolateNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/axis/utils/interpolators/number.js
// module id = 6HBm
// module chunks = 1